import { z } from "zod";

// ─── Clients ─────────────────────────────────────────────────────────────────
export const clientIdSchema = z.string().uuid("ID de cliente inválido");

export const cdcEnRutaConfigSchema = z.object({
  requireLoadRemito: z.boolean(),
  showTripPlanning:  z.boolean(),
})

export type CdcEnRutaConfig = z.infer<typeof cdcEnRutaConfigSchema>

export const createClientSchema = z.object({
  code:             z.string().min(1, "El código es requerido").max(10),
  fileId:           z.number().int().nullable().optional(),
  name:             z.string().min(1, "El nombre es requerido").max(200),
  sgtCodes:         z.array(z.string().max(250)).nullable().optional(),
  docId:            z.string().max(30).nullable().optional(),
  docTypeId:        z.string().uuid().nullable().optional(),
  address:          z.string().max(300).nullable().optional(),
  cityName:         z.string().max(150).nullable().optional(),
  postalCode:       z.string().max(10).nullable().optional(),
  stateId:          z.string().uuid().nullable().optional(),
  countryId:        z.string().uuid().nullable().optional(),
  avatarKey:        z.string().max(500).nullable().optional(),
  avatarUrl:        z.string().max(1000).nullable().optional(),
  cdcEnRutaConfig:  cdcEnRutaConfigSchema.nullable().optional(),
});

export const updateClientSchema = createClientSchema.partial();

export const clientQuerySchema = z.object({
  deleted:   z.enum(["true", "false"]).optional(),
  countryId: z.string().uuid().optional(),
  search:    z.string().optional(),
  sgt:       z.enum(["all", "with", "without"]).optional(),
  page:      z.coerce.number().int().min(1).optional().default(1),
  pageSize:  z.coerce.number().int().min(1).max(500).optional().default(25),
});

export const presignClientAvatarSchema = z.object({
  fileName: z.string().min(1),
  mimeType: z.string().regex(/^image\/(jpeg|png|webp|gif)$/),
})
export type PresignClientAvatar = z.infer<typeof presignClientAvatarSchema>

// ─── Exports ─────────────────────────────────────────────────────────────────
export type ClientId     = z.infer<typeof clientIdSchema>;
export type CreateClient = z.infer<typeof createClientSchema>;
export type UpdateClient = z.infer<typeof updateClientSchema>;
export type ClientQuery  = z.infer<typeof clientQuerySchema>;
